import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=374693e2&scoped=true"
import script from "./HomeCover.vue?vue&type=script&lang=js"
export * from "./HomeCover.vue?vue&type=script&lang=js"
import style0 from "./HomeCover.vue?vue&type=style&index=0&id=374693e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374693e2",
  null
  
)

export default component.exports